<ui-dialog>
  <ng-container title>{{ 'rootedDevice.title' | translate }}</ng-container>
  <ng-container description>{{ 'rootedDevice.description' | translate }}</ng-container>
  <button ui-button type="primary" data-cy="dismiss" primary-action (click)="dismiss()">
    {{ 'rootedDevice.dismiss' | translate }}
  </button>
</ui-dialog>
